import * as React from "react";
import Card from "@mui/material/Card";
import Icn from "../Icn";
import IconBtn from "../IconBtn";
import { colors } from "../../maps/colors";
import Tx from "../Tx";
import { useState } from "react";
import CameraInfoDialog from "../dialogs/CameraInfoDialog";
import CameraLive from "./CameraLive";

export default function InstallerCameraCard(props) {
  const {
    camera_info = {},
    profile_list,
    streamFullRtspUrl,
    rotate,
    hideActionButtons,
    ip,
    edge,
  } = props;
  // debugger;
  const camera = {
    cameraId: props._id
  };

  const [open_info_dialog, s_open_info_dialog] = useState(false);

  const getCameraSnapshot = () => {
    let url = "";

    url = profile_list?.length && profile_list[0].snapshot;

    return url;
  };

  const cameraSnapshotUrl = getCameraSnapshot();

  return (
    <Card
      onClick={props.onClick}
      sx={{
        width: "100%",
        marginBottom: "5px",
        background: props.selected ? colors.LIGHT_GREEN + "50" : "white",
      }}
    >
      <div style={{ padding: 5 }}>
        <Icn style={{ position: "relative", top: 4 }}>camera</Icn>{" "}
        <span style={{ fontSize: 18, fontWeight: 500 }}>{props.name}</span>
      </div>
      <div style={{ padding: 3 }}>
        <table style={{ fontSize: 12 }}>
          <tbody>
            {props.connectionType == "MANUAL" && (
              <>
                <tr>
                  <td>
                    <Tx>camera.rtspUrl</Tx>:
                  </td>
                  <td>{props.rtspUrl}</td>
                </tr>
              </>
            )}

            {props.connectionType == "ONVIF" && (
              <>
                <tr>                  
                  <td>
                    <Tx>camera.ip</Tx>:
                  </td>
                  <td>{props.ip}</td>
                </tr>
                <tr>                  
                  <td>
                    <Tx>S/N</Tx>:
                  </td>
                  <td>{props.serial_number}</td>
                </tr>
              </>
            )}
  
            {(props.pt || props.z) && (
              <tr>
                <td>
                  {props.pt ? "PT" : ""}
                  {props.z ? "Z" : ""}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {streamFullRtspUrl && (
          <CameraLive
            camera={camera}
            profile_list={profile_list}
            rtspUrl={streamFullRtspUrl}
            rotate={rotate}
            rotateEnabled={true}
            resolution={`480x270`}
          />
        )}
      </div>
      <div style={{ padding: 5 }}>
        {!hideActionButtons && (
          <>
            <IconBtn
              customtheme="small-gray"
              size="small"
              onClick={props.onEdit}
            >
              edit
            </IconBtn>
            <IconBtn
              customtheme="small-gray"
              size="small"
              style={{ marginLeft: 5 }}
              onClick={props.onDelete}
            >
              delete
            </IconBtn>
          </>
        )}
        {(Object.keys(camera_info).length || profile_list?.length) && (
          <IconBtn
            customtheme="small-gray"
            size="small"
            onClick={() => s_open_info_dialog(true)}
          >
            glassDetails
          </IconBtn>
        )}
      </div>

      {open_info_dialog && (
        <CameraInfoDialog
          {...props}
          onClose={() => s_open_info_dialog(false)}
        />
      )}
      {props.children}
    </Card>
  );
}
